import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './Translation.service';

/**
 * translate-format pipe
 *
 * Import using the TranslationsModule
 *
 * Usage in the template file:
 * {{ 'my.key' | translateFormat: param1 : param2 }}
 *
 * Each additional parameter is separated with a semi-colon (:)
 */
@Pipe({
    name: 'translateFormat',
    standalone: false
})
export class TranslateFormatPipe implements PipeTransform {
    constructor(private TR: TranslationService) {}

    /**
     * Translate the key value using a formatted string.
     *
     * @param key The key to translate
     * @param params Items to replace in the formatted string
     *
     * @returns Translated string
     */
    transform(key: string, ...params: any[]): string {
        const translatedValue = this.TR.keyFormatter(key, ...params);
        return translatedValue;
    }
}
